import React from 'react';
import { useNavigate } from 'react-router-dom';
import AddIcon from '../../assets/add-icon.svg';
import './CreateTripButton.css';

function CreateTripButton({ className = ""}) {
    const navigate = useNavigate();

    return (
        <button 
        className={`create-trip-btn ${className}`}
        onClick={() => navigate('/Trips')}
        >
        <img src={AddIcon} alt="Add icon" className="add-trip-btn" />
Create Trip
        </button>
    );

}

export default CreateTripButton;